import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { emailNewPassword } from "../../actions/Email";
import CONSTANTS, { PASSWORD_REGEX } from "../../helpers/constants";
import Button from "../Button";
import LWModal from "../Modal/Modal";
import TextInput from "../TextInput";
import "./ChangePassword.scss";
import {
  getCustomerID,
  setCustomerBranch,
  setCustomerPostcode,
  setCustomerStatus,
} from "../../helpers/functions";
import { getCustomer } from "../../selectors/Customer";
import { newPassword } from "../../api/EmailApi";

interface ChangePasswordProps {
  alternativeColours?: boolean;
  showAllCustomerDetails?: boolean;
  oldpassword?: string;
  useToken?: boolean;
  onClose?: () => void;
  setPasswordUpdated?: () => void;
  setPasswordUpdatedFailed?: () => void;
}

const ChangePassword = (props?: ChangePasswordProps) => {
  if (!props) {
    props = {
      alternativeColours: false,
      showAllCustomerDetails: true,
      onClose: () => {},
      setPasswordUpdated: () => {},
      setPasswordUpdatedFailed: () => {},
    };
  }

  const {
    alternativeColours,
    showAllCustomerDetails,
    onClose,
    oldpassword,
    setPasswordUpdated,
    setPasswordUpdatedFailed,
  } = props;

  const dispatch = useDispatch();
  const [emailSent, setEmailSent] = useState(false);
  const [name, setName] = useState("");
  const [cname, setCName] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRepassword] = useState("");
  const customer = useSelector(getCustomer);

  const passwordValidation = PASSWORD_REGEX.test(password);

  useEffect(() => {
    console.log(getCustomerID);
    setCustomerId(getCustomerID() as string);
  }, [dispatch]);

  const onChangePassword = async () => {
    let details = {
      customerId: customerId,
      password: oldpassword ?? "",
      newPassword: password,
      branchEmail: customer?.branch_email || "",
    } as any;

    if (showAllCustomerDetails) {
      details.contactEmail = email;
      details.contactName = cname;
      details.contactTel = tel;
      details.customerName = name;
    }

    const result = await newPassword(details, true);

    if (result?.data?.return_code != "OK") {
      if (setPasswordUpdatedFailed) {
        setPasswordUpdatedFailed();
      }
      return;
    }

    setCustomerPostcode(details.newPassword);

    setCustomerBranch("");
    setCustomerStatus("");
    setName("");
    setCName("");
    setEmail("");
    setTel("");
    setPassword("");
    setRepassword("");
    // setEmailSent(true);

    if (!showAllCustomerDetails) {
      // Add timeout to close modal after 3 seconds
      //setTimeout(() => {
      if (setPasswordUpdated) {
        setPasswordUpdated();
      }
      //  }, 3000);
    }
  };

  let errors = [];
  if (password && rePassword && password != rePassword) {
    errors.push("Your password and password confirmation must match");
  }
  if (password && customerId && password == customerId && errors.length == 0) {
    errors.push("Your password must not be the same as your customer Id");
  }

  console.log(passwordValidation, password, rePassword);
  console.log(password);
  console.log(errors);
  if (!passwordValidation && password && errors.length == 0) {
    errors.push(
      "Your password must be at least 6 characters and contain one uppercase letter, number or special character"
    );
  }
  let errorMessage = errors.join("\n");

  let saveDisabled = showAllCustomerDetails
    ? !customerId ||
      !email ||
      !tel ||
      !cname ||
      !name ||
      !password ||
      !rePassword ||
      password != rePassword ||
      !passwordValidation ||
      password == customerId
    : !customerId ||
      !password ||
      !rePassword ||
      password != rePassword ||
      !passwordValidation ||
      password == customerId;

  return (
    <>
      {!emailSent && (
        <div className="change-password-form">
          <div className="row  mb-2">
            <div className="col-12">
              <TextInput
                label="Customer Account Number"
                id="customerId"
                bgColor={alternativeColours ? "white" : "grey"}
                name="customerId"
                disabled={true}
                value={customerId}
                onBlur={(e) => setCustomerId(e)}
                onChange={(e) => setCustomerId(e)}
                placeholder="Enter your customer account number here"
              />
            </div>
          </div>
          {showAllCustomerDetails && (
            <>
              <div className="row mb-2">
                <div className="col-12">
                  <TextInput
                    label="Customer Name"
                    id="name"
                    bgColor={alternativeColours ? "white" : "grey"}
                    name="name"
                    value={name}
                    onBlur={(e) => setName(e)}
                    onChange={(e) => setName(e)}
                    placeholder="Enter your customer name here"
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-12">
                  <TextInput
                    label="Contact Name"
                    id="cname"
                    bgColor={alternativeColours ? "white" : "grey"}
                    name="cname"
                    value={cname}
                    onBlur={(e) => setCName(e)}
                    onChange={(e) => setCName(e)}
                    placeholder="Enter your contact name here"
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-12">
                  <TextInput
                    label="Contact Email"
                    id="email"
                    bgColor={alternativeColours ? "white" : "grey"}
                    name="email"
                    value={email}
                    onBlur={(e) => setEmail(e)}
                    onChange={(e) => setEmail(e)}
                    placeholder="Enter your contact email here"
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-12">
                  <TextInput
                    label="Contact Phone"
                    id="tel"
                    bgColor={alternativeColours ? "white" : "grey"}
                    name="tel"
                    value={tel}
                    onBlur={(e) => setTel(e)}
                    onChange={(e) => setTel(e)}
                    placeholder="Enter your contact phone here"
                  />
                </div>
              </div>
            </>
          )}
          <div className="row mb-2">
            <div className="col-12">
              <TextInput
                label="New Password Request"
                id="password"
                bgColor={alternativeColours ? "white" : "grey"}
                name="password"
                value={password}
                onBlur={(e) => setPassword(e)}
                onChange={(e) => setPassword(e)}
                type="password"
                placeholder="Enter your new password here"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <TextInput
                label="Confirm New Password Request"
                id="tel"
                bgColor={alternativeColours ? "white" : "grey"}
                name="repassword"
                value={rePassword}
                onBlur={(e) => setRepassword(e)}
                type="password"
                onChange={(e) => setRepassword(e)}
                placeholder="Re-enter your password here"
              />
            </div>
          </div>

          {errorMessage && (
            <div className="alert alert-danger mt-2" role="alert">
              {errorMessage}
            </div>
          )}

          <div className="row mt-5">
            <Button
              text="Request Password Update"
              disabled={saveDisabled}
              onClick={onChangePassword}
            />
          </div>
        </div>
      )}
      {emailSent && (
        <div className="alert alert-success" role="alert">
          Thank you for your request, our team will be in touch soon.
        </div>
      )}
    </>
  );
};

export default ChangePassword;
